import { Link } from "react-router-dom";

const renderCell = (key, value) => {
  switch (key) {
    // -------------------------------------------------------------
    // 1️⃣ DOCTOR INFO — Avatar + Name + Specialty
    // -------------------------------------------------------------
    case "doctorInfo":
      if (!value) return "-";

      return (
        <div className="d-flex align-items-center">
          <Link to={value.doctorLink} className="avatar avatar-md me-2">
            <img
              src={value.doctorImage}
              alt={value.doctorName || "doctor"}
              className="rounded-circle"
            />
          </Link>

          <Link to={value.doctorLink} className="text-dark fw-semibold">
            {value.doctorName}
            <span className="text-body fs-13 fw-normal d-block">
              {value.specialty}
            </span>
          </Link>
        </div>
      );

    // -------------------------------------------------------------
    // 2️⃣ STATUS — Colored Badge
    // -------------------------------------------------------------
    case "status":
      if (!value) return "-";

      return (
        <span
          className={`badge badge-soft-${value.type} rounded text-${value.type} fw-medium fs-13`}
        >
          {value.label}
        </span>
      );

    // -------------------------------------------------------------
    // 3️⃣ ACTIONS — Dropdown buttons
    // -------------------------------------------------------------
    case "actions":
      if (!Array.isArray(value)) return "-";

      return (
        <div className="action-item">
          <a href="javascript:void(0);" data-bs-toggle="dropdown">
            <i className="ti ti-dots-vertical"></i>
          </a>

          <ul className="dropdown-menu p-2">
            {value.map((btn, idx) => (
              <li key={idx}>
                <a
                  className="dropdown-item d-flex align-items-center"
                  href="javascript:void(0);"
                  data-bs-toggle={btn.type}
                  data-bs-target={btn.target}
                >
                  {btn.label}
                </a>
              </li>
            ))}
          </ul>
        </div>
      );

    // -------------------------------------------------------------
    // 4️⃣ DEFAULT HANDLER — For dateTime, mode, etc.
    // -------------------------------------------------------------
    default:
      return value ?? "-";
  }
};

export default renderCell;
